import { createOperationStore } from "./operationRuntime.mjs";
import type { OperationStore } from "./operationStore";

const sessions = new WeakMap<object, { scope: string; identity: object; store: OperationStore }>();

export function disposeOperationSession(owner: object) {
  sessions.get(owner)?.store.dispose();
  sessions.delete(owner);
}

/** The owner is the authenticated client/session, never an editor or selected route. */
export function operationSession(owner: object, scope: string, identity: object = owner): OperationStore {
  let current = sessions.get(owner);
  if (!current || current.scope !== scope || current.identity !== identity || !current.store.isActive()) {
    current?.store.dispose();
    current = { scope, identity, store: createOperationStore() };
    sessions.set(owner, current);
  }
  return current.store;
}
